<template>
  <header>
    <div style="height: 64px;width: 100%;"></div>
    <!--<top-column></top-column>-->
    <navbar></navbar>
  </header>
</template>

<script>
import topColumn from './components/topColumn'
import navbar from './components/navbar'
export default {
  name: 'myHeader',
  components: {topColumn, navbar}
}
</script>



// WEBPACK FOOTER //
// src/components/myHeader/index.vue